import React from 'react';
import { motion } from 'framer-motion';

const AnimatedOrb = () => {
  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
      {/* Main Orb */}
      <motion.div
        className="relative w-[500px] h-[500px]"
        animate={{
          rotate: 360,
        }}
        transition={{
          duration: 30,
          repeat: Infinity,
          ease: "linear"
        }}
      >
        {/* Outer glow ring */}
        <motion.div
          className="absolute inset-0 rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(6, 182, 212, 0.15) 0%, rgba(6, 182, 212, 0.05) 40%, transparent 70%)',
            filter: 'blur(40px)'
          }}
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.3, 0.5, 0.3]
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        
        {/* Main glassmorphic sphere */}
        <motion.div
          className="absolute inset-[80px] rounded-full backdrop-blur-xl"
          style={{
            background: 'linear-gradient(135deg, rgba(6, 182, 212, 0.1) 0%, rgba(14, 165, 233, 0.05) 50%, rgba(6, 182, 212, 0.1) 100%)',
            border: '1px solid rgba(6, 182, 212, 0.2)',
            boxShadow: '0 0 80px rgba(6, 182, 212, 0.2), inset 0 0 60px rgba(6, 182, 212, 0.1)'
          }}
          animate={{
            y: [-10, 10, -10],
          }}
          transition={{
            duration: 6,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          {/* Inner gradient orb */}
          <motion.div
            className="absolute inset-[40px] rounded-full"
            style={{
              background: 'radial-gradient(circle at 30% 30%, rgba(6, 182, 212, 0.3) 0%, rgba(14, 165, 233, 0.1) 50%, transparent 100%)',
            }}
            animate={{
              scale: [1, 1.05, 1],
            }}
            transition={{
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut",
              delay: 0.5
            }}
          />
        </motion.div>

        {/* Rotating ring accent */}
        <motion.div
          className="absolute inset-[60px] rounded-full"
          style={{
            border: '2px solid rgba(6, 182, 212, 0.3)',
            borderTopColor: 'rgba(6, 182, 212, 0.6)',
            borderRightColor: 'transparent',
          }}
          animate={{
            rotate: -360,
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "linear"
          }}
        />

        {/* Floating particles */}
        {[...Array(3)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-2 h-2 rounded-full"
            style={{
              background: 'rgba(6, 182, 212, 0.6)',
              boxShadow: '0 0 20px rgba(6, 182, 212, 0.8)',
              left: `${30 + i * 20}%`,
              top: `${20 + i * 25}%`
            }}
            animate={{
              y: [-20, 20, -20],
              x: [-10, 10, -10],
              opacity: [0.4, 0.8, 0.4],
            }}
            transition={{
              duration: 4 + i,
              repeat: Infinity,
              ease: "easeInOut",
              delay: i * 0.5
            }}
          />
        ))}
      </motion.div>
    </div>
  );
};

export default AnimatedOrb;